<template>
    <div>
      <div><h1 style="font-size: 20px;font-weight: 600">功能类型设置</h1></div>
        <a-button class="top_btn" type="primary" @click="()=>{  visibleForm = true; titleForm='功能类型设置' }"  > 添加
        </a-button>
      <a-popconfirm
          title="此操作将永久删除, 是否继续?"
          ok-text="确定"
          cancel-text="取消"
          @confirm="confirm('')"
          @cancel="()=>{}"
      >
        <a-button   :loading="loading"  >
          删除
        </a-button>
      </a-popconfirm>
        <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="false" rowKey="id"   :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" >
            <span slot="list_order" slot-scope="text, record">
        <a-input placeholder=" " v-model="record.list_order" class="inputs" size="small"/>
            </span>
            <span slot="action" slot-scope="text, record">
        <a @click="(record)=>{visibleForm = true; titleForm='功能类型设置'; editId=text.id ; }" >编辑 </a>
          <a-popconfirm
                  title="此操作将永久删除, 是否继续?"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="confirm(record)"
                  @cancel="()=>{}"
          >
   <a >删除</a>
  </a-popconfirm>
      </span>
        </a-table>
        <ColorForm :visible="visibleForm" :title="titleForm" :editId="editId"
                      @changVisible=" () => { this.visibleForm = false;this.editId='';  this.getList()}  "/>
    </div>

</template>

<script>
    import API from "./api";
    import ColorForm from "./components/colorForm"
    import {changStatus, removeById,orderList} from "../../../../../../../utils/utils"
    const columns = [

        {
            title: "功能名称",
            key: "name", 
            dataIndex: "name",
            width: "100px", ellipsis: true,
        },
      {
        title: "引导语标题",
        key: "title",
        dataIndex: "title",  ellipsis: true,
      },
      {
        title: "引导语描述",
        key: "description",
        dataIndex: "description",  ellipsis: true,
      },
      {
        title: "指令词",
        key: "word",
        dataIndex: "word",  ellipsis: true, width: "100px",
      },
      {
        title: "指令内容",
        key: "content",
        dataIndex: "content",  ellipsis: true,
      },
      {
        title: "备注",
        key: "remark",
        dataIndex: "remark",  ellipsis: true,
      },
        {
            title: "操作",
            key: "action",
            width: "200px",
            scopedSlots: {customRender: "action"}
        }
    ];
    export default {
        name: 'index',
        data() {
            return {
                visibleForm: false,
                titleForm: "",
                loading: true,
                editId: null,
                data: [],
                columns,
              selectedRowKeys: [],
                pagination: {
                    pageNo: 1,
                    pageSize: 20, // 默认每页显示数量
                    onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                    onChange: this.getList.bind(this), //点击页码事件
                    total: 0, //总条数
                    current: 0,
                    size: "small",
                    showTotal: total => `共 ${total} 条`,
                    showQuickJumper: true
                },
            }
        },
        created() {

        },
        components: {ColorForm},
        methods: {

          onSelectChange(selectedRowKeys) {
            this.selectedRowKeys = selectedRowKeys;
          },
            getList(page) {
                API.service.GET_LIST({a_ai_assistant_id:this.$route.query.id }).then(res => {
                    this.data = res.data.data
                    this.loading = false
                  this.selectedRowKeys=[]
                })
            },




            confirm(row) {
                let id=[]
              if(row==''){
                id=this.selectedRowKeys.toString()
              }else{
                id=row.id
              }

                removeById(API.service.DELE,  id ).then(res => {
                    if (res == true) {
                        this.getList()
                      this.selectedRowKeys=[]
                    }
                })
            },
        },
        mounted() {
          if(this.$route.query.type==1){
            this.getList()
          }

        }

    }
</script>
<style scoped>
    .inputs {
        display: inline-block;
        width: 70px
    }
</style>